import { Navigate, Outlet } from 'react-router-dom';

function ProtectedCorpRoute() {
    const isUserLogin = localStorage.getItem('isUserLogin');
    const isCorporationLogin = !!localStorage.getItem('corporationDetails');

    if (!isUserLogin) {
        return <Navigate to="/login" replace />;
    } else if (!isCorporationLogin) {
        return <Navigate to="/corporation-selection" replace />;
    }
    return <Outlet />;
}

export default ProtectedCorpRoute;
